const ASSET_BASE = process.env.REACT_APP_ASSETS_URL.replace(/\/$/, '');
const HOME_V2_ASSET_BASE = `${ASSET_BASE}/Home_v2`;

export const rootAsset = (filename) => `${ASSET_BASE}/${filename}`;
export const homeV2Asset = (filename) => `${HOME_V2_ASSET_BASE}/${filename}`;

export const HOME_V2_IMAGES = {
  emphasisText: homeV2Asset('EmphasisText.svg'),
  creator: homeV2Asset('homeCreator.svg'),
  bridge: homeV2Asset('bridge.svg'),
  dolhareubang: homeV2Asset('dolhareubang.svg'),
  gyeongbokgung: homeV2Asset('Gyeongbokgung.svg'),
  namsan: homeV2Asset('Namsan.svg'),
  airport: homeV2Asset('airport.svg'),
  parliament: homeV2Asset('Parliament.svg'),
  the63Building: homeV2Asset('the_63_building.svg'),
  textBoxWhite: homeV2Asset('textBox-white.svg'),
  smileGreen: homeV2Asset('smile-green.svg'),
  wavePurple: homeV2Asset('wave-purple.svg'),
  starGreen: homeV2Asset('star-green.svg'),
  start: homeV2Asset('start.svg'),
  profilePink: homeV2Asset('profile-pink.svg'),
  textBoxPink: homeV2Asset('textBox-pink.svg'),
  winkYellow: homeV2Asset('wink-yellow.svg'),
  tailGreen: homeV2Asset('tail-green.svg'),
  speechBubble: homeV2Asset('speechBubble.svg'),
  underlineGreen: homeV2Asset('underlineGreen.svg'),
  heroBackgroundMobileMini: homeV2Asset('hero-background-mobileMini.svg'),
  heroBackgroundMobile: homeV2Asset('hero-background-Mobile.svg'),
  heroBackgroundTabletH: homeV2Asset('hero-background-tabletH.svg'),
  heroBackgroundTabletV: homeV2Asset('hero-background-tabletV.svg'),
  heroBackgroundDesktopS: homeV2Asset('hero-background-desktopS.svg'),
  heroBackgroundDesktopL: homeV2Asset('hero-background-desktopL.svg'),
  cloverGreen: rootAsset('img-clover.svg'),
  section3Img1: homeV2Asset('section3-img1.svg'),
  section3Img2: homeV2Asset('section3-img2.svg'),
  section3Img3: homeV2Asset('section3-img3.svg'),
  section3Img4: homeV2Asset('section3-img4.svg'),
};
